import * as React from 'react';

import i18n from 'helper/i18n';
import noop from 'helper/noop';

import Coach from 'components/atoms/Coach';
import Counter from 'components/atoms/Counter';
import Icon from 'components/atoms/Icon';
import Link from 'components/atoms/Link';
import UIAsset from 'components/atoms/UIAsset';

import { CoachIsEnumType } from 'components/molecules/CoachSelector';

export type OnboardingStepProps = {
	modifier?: string;
	title: string;
	text?: string;
	image?: string;
	coach?: CoachIsEnumType;
	isLastStep?: boolean;
	count?: number;
	icon?: string;
	redirectUrl?: string;
	onFinishClick?: Function;
};

const OnboardingStep = ({
	modifier,
	title,
	text,
	image,
	coach,
	isLastStep,
	icon,
	count,
	onFinishClick = noop,
}: OnboardingStepProps) => {
	return (
		<div className={`m-onboarding-step${modifier ? ` m-onboarding-step--${modifier}` : ''}`}>
			<h2 className="m-onboarding-step__title">{title}</h2>
			<p className="m-onboarding-step__text">{text}</p>
			{image && (
				<div className="m-onboarding-step__image-wrapper">
					<UIAsset
						className="m-onboarding-step__image"
						src={`/img/svg/onboarding/${image}.svg`}
						alt={image}
					/>
				</div>
			)}
			{!image && (
				<div className="m-onboarding-step__icon-wrapper">
					{icon && <Icon iconName={icon} />}
					<div className="m-onboarding-step__icon-counter">
						{count && <Counter count={count} modifier="large" />}
					</div>
				</div>
			)}
			{coach && (
				<div className="m-onboarding-step__coach-box">
					<div className="m-onboarding-step__coach-wrap">
						<Coach coach={coach} gesture="full-onboarding" alt={coach} />
					</div>
				</div>
			)}
			{isLastStep && (
				<div className="m-onboarding-step__button js-m-onboarding-step__button">
					<Link
						openInNewWindow={false}
						iconRight="link-arrow"
						onClick={() => onFinishClick()}
						modifier="button"
						title={i18n('react.impulsCoach.components.onboarding.step.finishOnboardingButtonText')}
					/>
				</div>
			)}
			<div className="m-onboarding-step__bg">
				<UIAsset className="m-onboarding-step__bg-image" src="/img/svg/onboarding/triangle.svg" alt="" />
			</div>
		</div>
	);
};

OnboardingStep.displayName = 'Onboarding(Step)';

export default OnboardingStep;
